import VueRouter from "vue-router";
import Vue from 'vue';

import Detail from "../components/detail.vue"
import Index from "../components/index.vue"
import list from "../components/list.vue"
import privacy from "../components/privacy.vue"
import terms from "../components/terms.vue"

Vue.use(VueRouter);



  


  const router = new VueRouter({
    routes:[
        {
            path:'/',
            component:Index
        }
        ,{
        path:'/detail',
        name:'detail',
        component:Detail
    },
    // {
    //     path: '/wecome1',
    //     beforeEnter() {
    //       window.location.href = '/welcome1.html?flag=source_fb'; // 重定向到静态 HTML 文件
    //     }
    //   },
    //   {
    //     path: '/wecome2',
    //     beforeEnter() {
    //       window.location.href = '/welcome2.html?flag=source_fb'; // 重定向到静态 HTML 文件
    //     }
    //   },
    //   {
    //     path: '/wecome3',
    //     beforeEnter() {
    //       window.location.href = '/welcome3.html?flag=source_fb'; // 重定向到静态 HTML 文件
    //     }
    //   },
      {
        path: '/welcome1',
        beforeEnter() {
          window.location.href = '/welcome1.html'; // 重定向到静态 HTML 文件
        }
      },
      {
        path: '/welcome2',
        beforeEnter() {
          window.location.href = '/welcome2.html'; // 重定向到静态 HTML 文件
        }
      },
      {
        path: '/welcome3',
        beforeEnter() {
          window.location.href = '/welcome3.html'; // 重定向到静态 HTML 文件
        }
      }
    ,{
        path:'/list',
        component:list
    },
    {
        path:'/privacy',
        component:privacy
    }
    ,{
        path:'/terms',
        component:terms
    }
    ],
    
})

router.beforeEach((to, from, next) => {
    // 检查页面是否是通过刷新操作进入
    if (window.sessionStorage.getItem('isRefreshing')) {
      // 如果已经标记为刷新，则跳过刷新操作
      sessionStorage.removeItem('isRefreshing');
      next();
    } else {
      // 如果没有标记，表示是初次加载或首次跳转，标记为刷新并进行刷新
      sessionStorage.setItem('isRefreshing', 'true');
      window.location.reload();
    }
  });

  export default router;